'use client';

import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Eyebrow,
  Image,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreviewMostPopular } from '@/app_lib/types/ArticlePreview';
import type { ModuleType } from '@/app_lib/types/ContentCardTracking';

export const ArticleCardRailFull = ({
  article,
  className,
  index = 1,
  moduleType = 'rail_full',
  priority,
}: {
  article: ArticlePreviewMostPopular;
  className?: string;
  index?: number;
  moduleType?: ModuleType;
  priority?: boolean;
}) => {
  const generateContentCardTrackingData = useContentCardTrackingData();

  return (
    <ArticleCard
      className={className}
      variant='railFull'
    >
      <Eyebrow
        contentCardTrackingData={generateContentCardTrackingData({
          article: getExtendedArticle(article),
          cardPosition: index,
          clickTarget: 'eyebrow',
          moduleType,
        })}
        sectionName={article.sectionName}
        sectionUrl={article.sectionUrl}
      />
      <div className='flex flex-col gap-md md:gap-0 xl:gap-md'>
        <div className='flex gap-md md:gap-lg xl:gap-md'>
          <Title
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'headline',
              moduleType,
            })}
            title={article.title}
            url={article.url}
            variant='railFull'
          />
          <Image
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'image',
              moduleType,
            })}
            image={article.image}
            imageAlt={article.imageAlt?.trim() || article.title}
            priority={priority}
            url={article.url}
            variant='railFull'
          />
        </div>
        <div className='flex flex-col'>
          <AuthorByline
            authors={article.authors}
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'author',
              moduleType,
            })}
            variant='railFull'
          />
          <CardDate
            dateGmt={article.dateGmt}
            variant='railFull'
          />
        </div>
      </div>
    </ArticleCard>
  );
};
